import React, {useCallback, useRef} from "react"

import PopoverMenuOption, {
    PopoverMenuOptionSelectionType
} from "../../../../../../gd-components/popover-menu/popover-menu/menu-option";
import PopupMenuButton from "../../../../../../gd-components/popover-menu/popup-menu-button/popup-menu-button";
// @ts-ignore
import ProjectView_MoreMenu from "../../../../../../../layout/top/header/project/submenu/submenu-item/more-popover/more-menu"
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const";

type Props = {
    view        : any

    isSelected  : boolean

    onSelect    : callback
}

const debug = false
// const debug = "FieldSelectView_PopoverOption"

export default function FieldSelectView_PopoverOption(props:Props) {

    const refRight:any = useRef()

    const onTogglePopover = useCallback((value:boolean) => {
        debug && console.log(debug, 'onTogglePopover', value, refRight.current)
        gd.utils.Dom.toggleClass(refRight.current, 'show-popover', value)
    }, [refRight.current])

    const option = {
        value       : props.view.id,
        icon        : props.view.icon,
        label       : props.view.name,
        onClick     : ()=>{props.onSelect(props.view.id)}
    }

    return (
        <PopoverMenuOption option           = {option}
                           selectionType    = {PopoverMenuOptionSelectionType.BOLD}
                           isSelected       = {props.isSelected}>

            {props.view.hasMoreMenu &&
                <div ref={refRight} className="right h-100-percent">
                    <PopupMenuButton className          = "right-button flex-row-center-center h-100-percent ui5-ico-more s18"
                                     popoverClass       = "popover-project-view"
                                     attachment         = "top left"
                                     targetAttachment   = "top right"
                                     attachmentType     = {PopoverAttachmentType.VERTICAL}
                                     onTogglePopover    = {onTogglePopover}
                                     menuComponent      = {ProjectView_MoreMenu}
                                     menuParams         = {{
                                         view: props.view
                                     }}/>
                </div>}
        </PopoverMenuOption>
    )
}